import { render, staticRenderFns } from "./TeamRec.vue?vue&type=template&id=61152d16&lang=pug&"
import script from "./TeamRec.vue?vue&type=script&lang=js&"
export * from "./TeamRec.vue?vue&type=script&lang=js&"
import style0 from "./TeamRec.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports